/**
 * @fileoverview Settings card linking to the Connect Claude (MCP) page.
 * @module features/mcp/components/ConnectClaudeCard
 */

import type { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { KeyRound, Plug } from 'lucide-react'
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui'

/**
 * Small card surfaced on the main settings page that links to the MCP token
 * management screen. Kept presentational and intentionally lightweight.
 */
export function ConnectClaudeCard(): ReactElement {
  return (
    <Card className="glass-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2">
          <Plug className="size-5" />
          Connect Claude
        </CardTitle>
        <CardDescription>
          Issue personal access tokens so Claude (or any MCP client) can read your
          analytics over the Model Context Protocol.
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-4">
        <Button asChild variant="outline" size="sm" className="gap-1.5">
          <Link to="/dashboard/settings/mcp">
            <KeyRound className="size-3.5" />
            Manage MCP tokens
          </Link>
        </Button>
      </CardContent>
    </Card>
  )
}
